import { ChangeDetectionStrategy, Component, HostListener, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ef-password-toggler',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './password-toggler.component.scss',
  templateUrl: './password-toggler.component.html',
})
export class EfPasswordTogglerComponent {
  public passwordInput = input.required<HTMLInputElement>();

  public passwordVisible = signal(false);

  @HostListener('click')
  public onClick(): void {
    const newType: string = this.passwordInput().type === 'password' ? 'text' : 'password';

    this.passwordInput().type = newType;
    this.passwordVisible.set(newType === 'text');
  }
}
